import { render } from "./FootballAdminSetResult.vue?vue&type=template&id=495bbe73&scoped=true"
import script from "./FootballAdminSetResult.vue?vue&type=script&lang=js"
export * from "./FootballAdminSetResult.vue?vue&type=script&lang=js"

import "./FootballAdminSetResult.vue?vue&type=style&index=0&id=495bbe73&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-495bbe73"]])

export default __exports__